export const TIME_ZONE = 'Europe/Zurich';



// WEBPACK FOOTER //
// ./src/i18n/config.js